import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./PayCodesTable.scss";

const PayCodesTable = props => {
	const { paycodes, editPaycode, deletePaycodes } = props;
	const { lang } = global;
	const [selectedPaycodes, setSelectedPaycodes] = useState([]);
	const [paycodeFilter, setPaycodeFilter] = useState("");
	const [filteredPaycodes, setFilteredPaycodes] = useState([]);

	const updateSelectedPaycodes = id => {
		let paycodeList = [...selectedPaycodes];
		if (selectedPaycodes.some(paycode => paycode.Id === id)) {
			paycodeList = paycodeList.filter(paycode => paycode.Id !== id);
		} else {
			paycodeList.push(paycodes.find(paycode => paycode.Id === id));
		}
		setSelectedPaycodes(paycodeList);
	};

	const updateFilter = value => {
		const auxValue = value.toLowerCase();
		setPaycodeFilter(value);
		const paycodeList1 = paycodes.filter(paycode =>
			paycode.Name.toLowerCase().includes(auxValue),
		);
		const paycodeList2 = paycodes.filter(paycode =>
			paycode.Description.toLowerCase().includes(auxValue),
		);
		setFilteredPaycodes([...new Set([...paycodeList1, ...paycodeList2])]);
	};

	const erasePaycodes = () => {
		deletePaycodes(selectedPaycodes);
		setSelectedPaycodes([]);
	};

	useEffect(() => {
		if (paycodeFilter !== "") {
			updateFilter(paycodeFilter);
		}
	}, [paycodes]);

	return (
		<>
			<div className="row column-headers hidden-xs v-align">
				<div className="col-sm-3">
					<span>{lang.t("Short Code")}</span>
				</div>
				<div className="col-sm-3">
					<span>{lang.t("Description")}</span>
				</div>
				<div className="col-sm-3">
					<span>{lang.t("Status")}</span>
				</div>
				<div className="col-sm-3">
					<span>{lang.t("Modify")}</span>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<input
						className="form-control search-box"
						name="paycodeFilter"
						value={paycodeFilter}
						onChange={e => updateFilter(e.target.value)}
						placeholder={`${lang.t("Search pay code")}...`}
					/>
				</div>
			</div>
			<div className="list-body">
				<For
					each="paycode"
					of={paycodeFilter == null || paycodeFilter === "" ? paycodes : filteredPaycodes}
				>
					<div
						className="row"
						key={`paycode-${paycode.Id}`}
					>
						<div className="col-sm-3">
							<div className="row v-align-sm">
								<div className="col-sm-2 checkbox">
									<label htmlFor={`check_${paycode.Id}`}>
										<input
											type="checkbox"
											id={`check_${paycode.Id}`}
											name={`check_${paycode.Id}`}
											checked={selectedPaycodes.some(
												({ Id }) => Id === paycode.Id,
											)}
											onClick={e => e.stopPropagation()}
											onChange={() => updateSelectedPaycodes(paycode.Id)}
										/>
									</label>
								</div>
								<div
									className="col-sm-9"
									style={{ overflowWrap: "break-word" }}
								>
									<span>{paycode.Name}</span>
								</div>
							</div>
						</div>
						<div
							className="col-sm-3 paycode-item"
							style={{ overflowWrap: "break-word" }}
						>
							<span>{paycode.Description}</span>
						</div>
						<div className="col-sm-3 paycode-item">
							<span>{paycode.IsActive ? "Active" : "Inactive"}</span>
						</div>
						<div className="col-sm-3 paycode-item">
							<button
								type="button"
								className="btn btn-link"
								onClick={() => editPaycode(paycode.Id)}
							>
								{`${lang.t("Edit")}`}
							</button>
						</div>
					</div>
				</For>
			</div>
			<div className={`bulk-actions${selectedPaycodes.length > 0 ? " shown" : ""}`}>
				<div className="row bulk-button-container">
					<div className="col-xs-12 col-sm-3 col-md-2">
						<button
							type="button"
							className="btn btn-default btn-block"
							onClick={() => setSelectedPaycodes([])}
						>
							<span className="text-primary">{lang.t("Cancel")}</span>
						</button>
					</div>
					<div className="col-xs-12 col-sm-3 col-md-2">
						<button
							type="button"
							className="btn btn-default btn-block"
							onClick={() => erasePaycodes()}
						>
							<span className="text-danger">{lang.t("Delete")}</span>
						</button>
					</div>
				</div>
			</div>
		</>
	);
};

PayCodesTable.propTypes = {
	paycodes: PropTypes.array.isRequired,
	editPaycode: PropTypes.func.isRequired,
	deletePaycodes: PropTypes.func.isRequired,
};

export default PayCodesTable;
